import React, { useEffect } from "react";

import { gsap } from "gsap";

const GlobalCarnival = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    gradient: {
      background: "linear-gradient(90deg, rgba(128,0,0,1) 0%, rgba(252,263,17,1) 100%)",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  useEffect(() => {
    gsap.fromTo(
      ".section",
      {
        autoAlpha: 0,
        y: 100,
      },
      {
        autoAlpha: 1,
        y: 0,
        ease: "expo.inOut",
        duration: 1,
        stagger: 0.1,
      }
    );
  });

  return (
    <div className="w-full h-full text-white " style={styles.blackbg}>
      <div className="w-full max-w-2xl m-auto py-8 px-4">
        <div className="text-xl section" style={styles.blueText}>
          AIESEC in SLIIT
        </div>
        <div className="text-4xl font-bold section">
          <div className="p-4 rounded-lg" style={styles.gradient}>
            Global Carnival
          </div>
        </div>

        <div className="text-xl mt-1 text-gray-400 section">Application Package</div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Event Introduction</div>
          <p className="text-gray-400">
            <span className="rounded-md" style={styles.gradient}>
              &nbsp;Global Carnival&nbsp;
            </span>{" "}
            An event Organized by AIESEC in SLIIT, bringing together countries around the globe to share their cultural knowledge 
            with each other, to learn from each other and to bring back the Global Village spirit back to AIESEC in SLIIT.
            The Organizing Community will have a great chance to reach new heights while engaging and communicating with
            AIESEC members around the world.
          </p>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Timeline</div>
          <div>
            <span className="font-bold">Application Open - </span> <span className="text-gray-300">05th October</span> <br />
            <span className="font-bold">Application Deadline - </span> <span className="text-gray-300">10th October</span> <br />
            <span className="font-bold">OC Announcement - </span> <span className="text-gray-300">1st Week of November</span> <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Team Structure</div>
          <div>
            <span className="">OCP</span> <br />
            <span className="">OCVP Delegates x2</span> <br />
            <span className="">OCVP Marketing x3</span> <br />
            <span className="">OCVP External Relations x3</span> <br />
            <span className="">OCVP Finance</span> x1 <br />
            <span className="">OCVP Events</span> x1 <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Available Roles</div>
          <br />
          {/*  =====================================================  */}
          {/* <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #FFC845" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#FFC845" }}>
              OCP <span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Lead the OC team a financially and logistically successful event, in which the following responsibilities are achieved.</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Ensure the event is meeting its goals agreed upon between the OC and the EB of AIESEC in SLIIT</li>
                <li>Ensure correct communication and reporting with OC and EB</li>
                <li>Set and assure the respect of a specific timeline and an action plan</li>
                <li>Manage the OC</li>
                <li>Setting out initial Organizing timelines for all the OCVPs</li>
                <li>Setting out ER raising plan together with OEVP PD</li>
                <li>Plan OC tasks and OC performance</li>
                <li>Plan initial marketing ad PR campaigns together with OEVP Marketing</li>
              </ul>
            </div>
          </div> */}
          {/* <br /> */}
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #0373f3" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#0373f3" }}>
              OCVP Delegates <span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Being the first touchpoint between Global Carnival delegates and AIESEC in SLIIT</li>
                <li>Setting up expectation setting and internal briefing about the requirements</li>
                <li>Answering all the inquiries from the participants</li>
                <li>Creating and managing a database of the participants</li>
                <li>Managing invitations of participants</li>
                <li>Managing the registrations of the participants</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in Coordinating and negotiating with people</li>
                <li>Experience in event management and coordination</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #F85A40" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#F85A40" }}>
              OCVP Marketing <span className="text-gray-500"> x3</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Approach electronic media for Pre-promotions</li>
                <li>Coordinate interviews with the media</li>
                <li>Work with ER team for sales</li>
                <li>Design and launch promotional materials to attract participants</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in partnership management with variety of Stakeholders</li>
                <li>Experience in planning and running marketing campaigns</li>
                <li>Experience on designing promotional material for an event</li>
                <li>Experience in photo editing and video editing softwares</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #FFC845" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#FFC845" }}>
              OCVP External Relations <span className="text-gray-500"> x3</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Conduct market researches on potential partners together with OEVP PD</li>
                <li>Approach potential companies for sponsorships </li>
                <li>Follow-ups and sponsorship delivery</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Market research experience of partnership management with a variety of stakeholders</li>
                <li>Experience on event management and sales</li>
                <li>Experience in planning and running PR and marketing campaigns for events</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          {/* <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #037ef3" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#037ef3" }}>
              OCVP Logistics <span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Coordinate with venue management to facilitate the event</li>
                <li>Estimate the providing learning and delivery materials</li>
                <li>Work with ER team for sales</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in event management</li>
                <li>Experience in corporate sales negotiation</li>
              </ul>
            </div>
          </div>{" "}
          <br /> */}
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #0CB9C1" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#0CB9C1" }}>
              OCVP Finance<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Preparing event budget</li>
                <li>Collecting and documentation of all the supporting documents</li>
                <li>Preparing the event report</li>
                <li>Expenses an partnership tracking</li>
                <li>Ensure partnership delivery</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in budget preparation</li>
                <li>Experience in budgetary control</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #0373f3" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#0373f3" }}>
              OCVP Events<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Delivering the model of the event</li>
                <li>Managing guests invitation</li>
                <li>Ensuring all systems are in place for guests</li>
                <li>Securing guest speakers and ensuring their objectives are achieved</li>
                <li>Managing the experience of the guests</li>
                <li>Responsible for the smooth flow of the event</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in event planning and management</li>
                <li>Experience in attention to detail and working under pressure</li>
                <li>Professional communication skills</li>
              </ul>
            </div>
          </div>
          {/** Contact Info ***/}
          <div className="mt-8">
            <div className="w-full h-1 bg-gray-700 mb-8"></div>
            <div className="text-2xl mb-4 font-semibold">Contact Info</div>
            <div>
              <div>For any clarifications, </div>
              <div style={styles.blueText} className="text-3xl">
                Senesh Wijayarathne
              </div>
              <div className="text-gray-400">OEVP iGV IRM – AIESEC in SLIIT</div>
              <div className="text-gray-400">senesh.wijayarathne@aiesec.net</div>
              <div className="text-gray-400">+94 77 720 7753</div>
            </div>
          </div>
          <a href="https://bit.ly/global-carnival-oc" target="_blank" rel="noreferrer">
            <div className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer" style={{ background: "#037ef3" }}>
              Apply Now
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default GlobalCarnival;
